import React from 'react'
import AnsQandAUserAll from '../ansuser/AnsQandAUserAll'
import MenuAdmin from './navAdmin/Menu'

function AnsAdmin() {
    return (
        <div className='global-page'>
            <MenuAdmin menuActive={'ans'} />
            <AnsQandAUserAll roleUser={'Admin'}/>
        </div>
    )
}

export default AnsAdmin